import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api, { getAllRecords } from "../api";
import SearchableSelect from "../components/SearchableSelect";

export default function VendorDriverManagementPage({ vendorId }) {
  const [vendor, setVendor] = useState(null);
  const [vehicles, setVehicles] = useState([]);
  const [form, setForm] = useState({
    fullName: "",
    mobileNo: "",
    vehicleId: "",
  });
  const [message, setMessage] = useState("");
  const [saving, setSaving] = useState(false);

  const load = async () => {
    try {
      const [response, rows] = await Promise.all([
        api.get("/vehicles/vendors"),
        getAllRecords("/vehicles"),
      ]);
      setVendor(
        (response.data.data || []).find((item) => item._id === vendorId) ||
          null,
      );
      setVehicles(
        rows.filter(
          (item) =>
            String(item.vendorId?._id || item.vendorId) === String(vendorId),
        ),
      );
    } catch {
      setMessage("Unable to load vendor driver assignments.");
    }
  };
  useEffect(() => {
    load();
  }, [vendorId]);
  const vehicleFor = (id) =>
    vehicles.find((item) => String(item._id) === String(id));
  const locationFor = (id) => {
    const vehicle = vehicleFor(id);
    return vehicle
      ? `${vehicle.clientName || "-"}${vehicle.clientLocationName ? ` / ${vehicle.clientLocationName}` : ""}`
      : "Not assigned";
  };
  const submit = async (event) => {
    event.preventDefault();
    if (!form.vehicleId) {
      setMessage("Select a vendor vehicle before adding the driver.");
      return;
    }
    setSaving(true);
    setMessage("");
    try {
      await api.post(`/vehicles/vendors/${vendorId}/drivers`, form);
      setForm({ fullName: "", mobileNo: "", vehicleId: "" });
      setMessage("Temporary driver saved and available in Attendance.");
      load();
    } catch (error) {
      setMessage(
        error.response?.data?.message || "Unable to save the temporary driver.",
      );
    } finally {
      setSaving(false);
    }
  };
  return (
    <div className="vendor-detail-page vendor-driver-page">
      <div className="vehicle-heading">
        <div>
          <p>VENDOR MANAGEMENT</p>
          <Link
            className="vendor-back"
            to={`/staff/dashboard/vendor-management/${vendorId}`}
          >
            ← Back to vehicles
          </Link>
          <h2>{vendor?.name || "Vendor"} Drivers</h2>
        </div>
      </div>
      <section className="portal-module vendor-driver-management">
        <div className="vendor-driver-intro">
          <div>
            <p>TEMPORARY DRIVER ASSIGNMENT</p>
            <h3>Manage Drivers</h3>
            <span>
              Assign a temporary driver to a vendor vehicle for attendance.
            </span>
          </div>
          <b>{vendor?.externalDrivers?.length || 0}</b>
        </div>
        <form className="vendor-driver-form" onSubmit={submit}>
          <label>
            Vehicle
            <SearchableSelect
              value={form.vehicleId}
              options={vehicles.map((item) => ({
                value: item._id,
                label: item.vehicleNumber,
              }))}
              placeholder="Type or search vehicle number"
              onChange={(vehicleId) => setForm({ ...form, vehicleId })}
              required
            />
          </label>
          <label>
            Driver Name
            <input
              value={form.fullName}
              placeholder="Enter driver name"
              onChange={(event) =>
                setForm({ ...form, fullName: event.target.value })
              }
              required
            />
          </label>
          <label>
            Mobile Number
            <input
              value={form.mobileNo}
              placeholder="10-digit mobile number"
              inputMode="numeric"
              maxLength="10"
              pattern="\d{10}"
              onChange={(event) =>
                setForm({
                  ...form,
                  mobileNo: event.target.value.replace(/\D/g, ""),
                })
              }
              required
            />
          </label>
          <button className="add-vehicle-button" disabled={saving}>
            {saving ? "Saving…" : "+ Add Driver"}
          </button>
        </form>
        {message && <div className="vehicle-toast">{message}</div>}
        <div className="vendor-drivers-list">
          <h3>Temporary Driver Vehicle Assignments</h3>
          {vendor?.externalDrivers?.length ? (
            <div className="vendor-assignment-table">
              <table>
                <thead>
                  <tr>
                    <th>Vehicle Number</th>
                    <th>Temporary Driver</th>
                    <th>Mobile Number</th>
                    <th>Working Location</th>
                  </tr>
                </thead>
                <tbody>
                  {vendor.externalDrivers.map((item) => (
                    <tr key={item._id}>
                      <td>
                        {vehicleFor(item.vehicle)?.vehicleNumber ||
                          "Not assigned"}
                      </td>
                      <td>{item.fullName}</td>
                      <td>{item.mobileNo}</td>
                      <td>{locationFor(item.vehicle)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <p>
              No temporary driver assignments have been added for this vendor.
            </p>
          )}
        </div>
      </section>
    </div>
  );
}
